import { useState } from "react";
import { api, apiError } from "@/api";

const track = (name, props = {}) => {
  try { window.posthog?.capture(name, props); } catch { /* noop */ }
  try { window.gtag?.("event", name, props); } catch { /* noop */ }
};

const DONE_KEY = "ank_notify_done";

export function notifyDone() {
  try { return localStorage.getItem(DONE_KEY) === "1"; } catch { return false; }
}

export default function NotifyCapture({ source = "feed", testid = "notify" }) {
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [state, setState] = useState(notifyDone() ? "done" : "idle"); // idle|busy|done|error
  const [err, setErr] = useState("");

  if (state === "done") {
    return (
      <p className="notify-done" data-testid={`${testid}-done`}>
        YOU'RE ON THE LIST — first access lands in your inbox.
      </p>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || state === "busy") return;
    setState("busy");
    setErr("");
    try {
      await api.post("/community/notify", { email: email.trim(), website: website || undefined });
      try { localStorage.setItem(DONE_KEY, "1"); } catch { /* noop */ }
      track("notify_signup", { source });
      setState("done");
    } catch (e2) {
      setErr(apiError(e2));
      setState("idle");
    }
  };

  return (
    <form className="notify-form" onSubmit={submit} data-testid={`${testid}-form`}>
      <span className="notify-label">GET FIRST ACCESS TO THE NEXT SESSION</span>
      <div className="notify-row">
        <input
          type="email"
          required
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="notify-input"
          data-testid={`${testid}-email`}
          aria-label="Email for first access"
        />
        <input
          type="text"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          className="pol-hp"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
        />
        <button type="submit" className="notify-btn" disabled={state === "busy"} data-testid={`${testid}-submit`}>
          {state === "busy" ? "…" : "NOTIFY ME"}
        </button>
      </div>
      {err && <p className="notify-err" data-testid={`${testid}-error`}>{err}</p>}
    </form>
  );
}
